import { useProvider, useUUID } from '~/Hooks';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IUploadedImage } from '~/Models/DTO/UploadedImage.mode';
import { convertImagesToBase64 } from '~/Helpers/ConvertImageToBase64.helper';

export const useRequestUploadImages = () => {
  const { currentProvider } = useProvider();
  const { createUUID } = useUUID();

  const uploadImagesFromUrl = async (imageUrlList: string[]) => {
    const imagesConverted = await convertImagesToBase64(imageUrlList);

    const uploadAllImages = imagesConverted.map((imageData) =>
      requestReactQuery<IUploadedImage>({
        url: routeReplacer(CORE_SERVICE_URLS.UPLOAD_IMAGE, {
          domain: currentProvider?.domain || '',
        }),
        data: {
          name: createUUID(),
          imageData,
        },
        config: { method: 'POST' },
      }),
    );

    return Promise.all(uploadAllImages);
  };

  return {
    uploadImagesFromUrl,
  };
};
